import "./App.css";
import { useState, useEffect } from "react";
import { ArrowNarrowLeft } from "tabler-icons-react";
import {
  Button,
  Modal,
  Text,
  MantineProvider,
  ColorSchemeProvider,
} from "@mantine/core";

import Spline from "@splinetool/react-spline";
import {
  Authenticator,
  Flex,
  Grid,
  View,
  CheckboxField,
} from "@aws-amplify/ui-react";
import { LinkedContext } from "./Contexts/LinkedContext";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { SignInHeader } from "./SignInHeader";
import { SignInFooter } from "./SignInFooter";
import { SignUpHeader } from "./SignUpHeader";
import { SignUpFooter } from "./SignUpFooter";
import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";
import NewMenu from "./Components/MainPage";

const components = {
  Header,
  SignIn: {
    Header: SignInHeader,
    Footer: SignInFooter,
  },
  SignUp: {
    FormFields() {
      const { validationErrors } = Authenticator();
      const [openedPrivacy, setOpenedPrivacy] = useState(false);
      const [openedTermsOfService, setOpenedTermsOfService] = useState(false);
      return (
        <>
          <Authenticator.SignUp.FormFields />
          <div style={{ display: "flex", alignItems: "center" }}>
            <CheckboxField name="acknowledgement" value="yes" />
            <Text ml="xs">I agree with the</Text>
            <Button
              variant="subtle"
              radius="sm"
              size="md"
              p={0}
              ml={5}
              mr={5}
              onClick={() => {
                setOpenedPrivacy(true);
              }}
            >
              Privacy Policy
            </Button>
            <Text>&</Text>
            <Button
              variant="subtle"
              radius="sm"
              size="md"
              p={0}
              ml={5}
              onClick={() => {
                setOpenedTermsOfService(true);
              }}
            >
              Terms of Service
            </Button>
          </div>
          <Modal
            size={1200}
            opened={openedPrivacy}
            onClose={() => setOpenedPrivacy(false)}
            overflow="outside"
            lockScroll
            transitionDuration={500}
            transitionTimingFunction="ease-in-out"
          >
            <PrivacyPolicy setOpenedPrivacy={setOpenedPrivacy} />
          </Modal>
          <Modal
            size={1200}
            opened={openedTermsOfService}
            onClose={() => setOpenedTermsOfService(false)}
            overflow="outside"
            lockScroll
            transitionDuration={500}
            transitionTimingFunction="ease-in-out"
          >
            <TermsOfService setOpenedTermsOfService={setOpenedTermsOfService} />
          </Modal>
        </>
      );
    },
    Header: SignUpHeader,
    Footer: SignUpFooter,
  },
  Footer,
};

function App({ user }) {
  // const [twitchLinked, setTwitchLinked] = useState(true);

  const [colorScheme, setColorScheme] = useState(
    localStorage.getItem("color") ?? "light"
  );
  const toggleColorScheme = (ColorScheme) =>
    setColorScheme(colorScheme === "dark" ? "light" : "dark");

  useEffect(() => {}, []);

  return (
    <>
          <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "absolute",
          background: "#fff",
          width: "100%",
          padding: 20,
          // borderBottom: "solid 3px #000",
          textAlign: "center",
          boxShadow: "2px 2px 2px 2px #00000010",
          cursor: "pointer"
        }}
        onClick={() => window.open("https://www.adly.gg" , "_self")}
      >
        <ArrowNarrowLeft
          size={24}
          strokeWidth={2}
          color={"black"}
          opacity={"50%"}
        />
        <div style={{ opacity: "60%", fontWeight: 600, marginLeft: 5 }}>
          Back to homepage
        </div>
      </div>
      <Grid templateColumns={{ base: "1fr 0", medium: "1fr 1fr" }}>
        <Flex backgroundColor={"#35A2EB15"} justifyContent="center">
          <Authenticator
            components={components}
            services={{
              async validateCustomSignUp(formData) {
                if (!formData.acknowledgement) {
                  return {
                    acknowledgement:
                      "You must agree to the Terms & Conditions.",
                  };
                }
              },
            }}
            // formFields={formFields}
          >
            {() => (
              <ColorSchemeProvider
                colorScheme={colorScheme}
                toggleColorScheme={toggleColorScheme}
              >
                <MantineProvider
                  withNormalizeCSS
                  withGlobalStyles
                  theme={{
                    colorScheme,
                  }}
                >
                  {/* <LinkedContext.Provider
                    value={{ twitchLinked, setTwitchLinked }}
                  > */}
                    <NewMenu />
                  {/* </LinkedContext.Provider> */}
                </MantineProvider>
              </ColorSchemeProvider>
            )}
          </Authenticator>
        </Flex>
        <View height="100vh">
          <Spline scene="https://prod.spline.design/Cc-gvYlMQfDUC78K/scene.splinecode" />
        </View>
      </Grid>
    </>
  );
}

export default App;
